import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AttendenceExportService } from '../../attendance-export.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';

@Component({
    selector: 'app-attendance-data-export',
    standalone: false,
    templateUrl: './attendance-data-export.component.html',
    styleUrls: ['./attendance-data-export.component.scss']
})
export class AttendanceDataExportComponent implements OnInit {
    @Input() proceedData: any; // Input for the API response data
    @Input() attendanceHeader: any; // Input for header data from session
    @Output() proceed = new EventEmitter<void>();
    @Output() back = new EventEmitter<void>();

    dateRange: string = '';
    isDownloading: boolean = false;
    showExportMessage = false;

    constructor(
        private attendenceExportService: AttendenceExportService,
        private snackBarService: SnackBarService
    ) { }

    ngOnInit(): void {
        // =================================================================
        // FIX APPLIED:
        // This block is commented out because it was overwriting the fresh 
        // @Input data (Week 32) with stale data from sessionStorage (Week 34) 
        // when navigating forward in the process. 
        // The correct data is already available via @Input properties.
        // =================================================================

        // const savedState = sessionStorage.getItem('attendance_data_export_state');
        // if (savedState) {
        //   try {
        //     const state = JSON.parse(savedState);
        //     this.proceedData = state.proceedData;
        //     this.attendanceHeader = state.attendanceHeader;
        //     //sessionStorage.removeItem('attendance_data_export_state');
        //   } catch {}
        // }

        console.log('AttendanceDataExportComponent initialized');
        console.log('proceedData:', this.proceedData);
        console.log('attendanceHeader:', this.attendanceHeader);

        // Update attendanceHeader with latest data from proceedData if needed
        if (!this.attendanceHeader ||
            (this.proceedData?.data?.weekNo && this.attendanceHeader?.weekNo !== this.proceedData.data.weekNo)) {
            // Get the latest values from proceedData
            const exportData = this.proceedData?.data;
            if (exportData) {
                this.attendanceHeader = {
                    payroll_group_code: exportData.payroll_group_code || exportData.payrollgroup_code,
                    payroll_group_id: exportData.payroll_group_id,
                    year: exportData.year,
                    weekNo: exportData.weekNo,
                    start_date: exportData.start_date,
                    end_date: exportData.end_date
                };
                console.log('Updated attendanceHeader with latest data:', this.attendanceHeader);
            }
        }

        // Format date range if available
        if (this.attendanceHeader?.start_date && this.attendanceHeader?.end_date) {
            this.dateRange = `${this.attendanceHeader.start_date} - ${this.attendanceHeader.end_date}`;
        }
    }

    onExportAttendanceProceed() {
        if (this.isDownloading) return;
        this.isDownloading = true;
        this.showExportMessage = true;
        const exportData = this.proceedData?.data;

        // Build payload from attendanceHeader
        const payload = {
            payroll_group_id: exportData.payroll_group_id,
            year: this.attendanceHeader?.year,
            weekNo: this.attendanceHeader?.weekNo
        };

        this.attendenceExportService.downloadExcel(payload).subscribe({
            next: (response: Blob) => {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const text = reader.result as string;
                        const json = JSON.parse(text);
                        if (json.status === 'NO_DATA_FOUND') {
                            this.snackBarService.openSnackBar({
                                message: 'No data found.',
                                title: 'No Data!!!',
                                type: 'warn'
                            });
                            this.isDownloading = false;
                            return;
                        }
                    } catch (e) {
                        const blob = new Blob([response], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');

                        // FORMAT: P{FINANCIAL YEAR}-W{WEEK NO}-{PAYROLL GROUP}.CSV
                        const year = this.attendanceHeader?.year || '';
                        const week = this.attendanceHeader?.weekNo || '';
                        const group = this.attendanceHeader?.payroll_group_code || '';
                        const fileName = `P${year}-W${week}-${group}.csv`;

                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                        this.isDownloading = false;
                    }
                };
                reader.readAsText(response);
            },
            error: (error) => {
                this.snackBarService.openSnackBar({
                    message: 'Export failed.',
                    title: 'Error',
                    type: 'error'
                });
                this.isDownloading = false;
            }
        });
    }

    onBack() {
        // Save current state before navigating back (this is useful and should be kept)
        sessionStorage.setItem('attendance_data_export_state', JSON.stringify({
            proceedData: this.proceedData,
            attendanceHeader: this.attendanceHeader
        }));
        this.back.emit();
    }

    hasExportData(): boolean {
        // Check if proceedData has non-empty employee_attendance_export array
        return Array.isArray(this.proceedData?.data?.employee_attendance_export) &&
            this.proceedData.data.employee_attendance_export.length > 0;
    }


}